(function () {
  'use strict';

  // Keeps the theme's (hidden) variant picker in step with the Monster Cart "Buy more save more"
  // bundle on product pages.
  //
  // Why: on products that use the bundle (see sbs_hide_picker_handles in sections/main-product.liquid)
  // customers choose colour and size in Monster's own <select>s, and the theme's variant picker is
  // hidden. Monster's Add to Cart reads its own selects, but the dynamic checkout buttons
  // (Shop Pay / Apple Pay / Google Pay) buy whatever the form's hidden [name="id"] holds - and that
  // only follows the theme picker, which stayed on the default variant. Customers who picked Brown
  // and paid with Apple Pay were sent Khaki / 32".
  //
  // How: whenever the bundle's pair #1 changes (or first renders), select the same option values in
  // the theme picker and fire the 'change' event it listens for, exactly as the theme does for URL
  // swatch params. The theme then fetches the variant and updates the [name="id"] inputs (main and
  // sticky), price, availability and the sticky bar itself.
  //
  // Does nothing unless both the Monster bundle (#mu_product_upsell) and a theme variant picker are
  // on the page. Monster's own code is untouched.

  var ROOT_SELECTOR = '#mu_product_upsell';
  var syncTimer = null;

  function pickerFor(root) {
    var section = root.closest('.shopify-section');
    return section ? section.querySelector('variant-picker') : null;
  }

  // Listed option groups of the theme picker, keyed by option name ("Color", "Waist Size").
  function pickerOptions(picker) {
    var options = {};
    picker.querySelectorAll('.option-selector[data-option]').forEach(function (selector) {
      options[selector.dataset.option] = selector;
    });
    return options;
  }

  function valuesOf(selector) {
    return Array.prototype.map.call(selector.querySelectorAll('input.js-option'), function (input) {
      return input.value;
    });
  }

  // Colour and size chosen for pair #1: the first bundle select whose values belong to each
  // picker option. Matched on values rather than position, so Monster can reorder its selects.
  function desiredSelection(root, options) {
    var card = root.querySelector('[data-monster-product-selected="true"]') || root;
    var selects = card.querySelectorAll('select');
    var desired = {};

    Object.keys(options).forEach(function (name) {
      var values = valuesOf(options[name]);
      for (var i = 0; i < selects.length; i += 1) {
        var optionValues = Array.prototype.map.call(selects[i].options, function (o) { return o.value; });
        var belongs = optionValues.length > 0 && optionValues.every(function (v) { return values.indexOf(v) !== -1; });
        if (belongs) {
          desired[name] = selects[i].value;
          break;
        }
      }
    });
    return desired;
  }

  function sync() {
    syncTimer = null;
    var root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;
    var picker = pickerFor(root);
    if (!picker) return;

    var options = pickerOptions(picker);
    var desired = desiredSelection(root, options);
    var names = Object.keys(options);
    // Only act when every picker option has a matching bundle select.
    if (!names.length || names.some(function (name) { return !desired[name]; })) return;

    var changed = false;
    for (var i = 0; i < names.length; i += 1) {
      var selector = options[names[i]];
      // Only the listed (radio) picker style is supported - it's what these products use.
      if (selector.dataset.selectorType !== 'listed') return;
      var input = Array.prototype.find.call(selector.querySelectorAll('input.js-option'), function (el) {
        return el.value === desired[names[i]];
      });
      if (!input) return;
      if (!input.checked) {
        input.checked = true;
        changed = true;
      }
    }
    if (!changed) return;

    // Fired on the picker itself rather than a radio: a radio's data-variant-id reflects the other
    // options as they were, so with colour and size changing together it can name the wrong
    // variant. Without one, the theme looks the variant up from the checked option values.
    picker.dispatchEvent(new CustomEvent('change', { bubbles: true, detail: { noFocus: true } }));
  }

  // Colour and size often change together (tier switches, Monster resetting rows), so batch them.
  function queueSync() {
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(sync, 60);
  }

  function init() {
    // Delegated: the bundle is injected by the app and re-rendered when the tier changes.
    document.addEventListener('change', function (evt) {
      if (evt.target.matches && evt.target.matches(ROOT_SELECTOR + ' select')) queueSync();
    });
    // Catches the bundle's first render and tier re-renders; a no-op once picker and bundle agree.
    // Only mutations in or around the bundle count, so other busy parts of the page can't keep
    // pushing the sync back.
    new MutationObserver(function (mutations) {
      var root = document.querySelector(ROOT_SELECTOR);
      if (!root) return;
      var relevant = mutations.some(function (m) {
        return root.contains(m.target) || m.target.contains(root);
      });
      if (relevant) queueSync();
    }).observe(document.body, { childList: true, subtree: true });
    queueSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
